import { useAlert } from '@ads/components-react';
import { useQuery } from '@tanstack/react-query';

export function useJsonData(jsonUrl: string | null | undefined) {
  const { alert } = useAlert();
  return useQuery({
    queryKey: ['json-data', jsonUrl],
    queryFn: async () => {
      if (!jsonUrl) throw new Error('URL não disponível');
      const res = await fetch(jsonUrl);
      if (!res.ok) {
        alert({
          alertType: 'danger',
          title: 'Erro ao buscar JSON',
        });
        throw new Error('Erro ao buscar JSON');
      }
      return (await res.json()) as Record<string, unknown>;
    },
    enabled: !!jsonUrl,
    staleTime: 0, // canvas JSON must always be fetched fresh — blob content can change at the same URL
  });
}
